<button id="global-modal-focus-origin" class="modal-focus-origin" type="button" tabindex="-1">
  Modal
</button>

<tds-modal #modalEl selector="#global-modal-focus-origin" (tdsClose)="close('closed')">
  <span slot="body"> {{ config.body }} </span>

  <span slot="actions" class="tds-u-flex tds-u-gap1">
    @for (a of actions; track a.text) {
      <tds-button
        [text]="a.text"
        size="md"
        [variant]="a.variant"
        (click)="onActionClick(a)"
      ></tds-button>
    }
  </span>
</tds-modal>
